import script from "./shezhi.vue?vue&type=script&setup=true&lang=js"
export * from "./shezhi.vue?vue&type=script&setup=true&lang=js"

import "./shezhi.vue?vue&type=style&index=0&id=1ab84814&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab84814"]])

export default __exports__